<template>
  <div class="activities mdl-shadow--2dp">
    <table class="mdl-data-table mdl-js-data-table">
      <thead>
        <tr>
          <th class="time-col">Time</th>
          <th class="email-col">Email</th>
          <th class="org-col">Organisation</th>
          <th class="action-col">Action</th>
          <th class="link-col">Link</th>
          <th class="details-col">Details</th>
        </tr>
      </thead>
      <tbody>
        <tr is="activity-row"
          v-for="activity in activities"
          :key="activity.id"
          :activity="activity">
        </tr>
        <tr v-if="no_more" class='nomore'>
          <td colspan=6>End of results!</td>
        </tr>
      </tbody>
    </table>
    <div v-infinite-scroll="loadMore"
         infinite-scroll-disabled="busy"
         infinite-scroll-distance=100>
    </div>
  </div>
</template>

<script>
import ActivityRow from "./activity_row"
import URI from "urijs"
import infiniteScroll from "vue-infinite-scroll"

function matches(str, search) {
  var parts = search.split(/ +/);
  for(var idx in parts) {
    var term = parts[idx];
    if(!~str.indexOf(term)) {
      return false
    }
  }
  return true
}
function matchesQuery(querydata, activity) {
  var string = JSON.stringify(activity)
  if(querydata.q && !matches(string, querydata.q)) {
    return false
  }
  if(querydata.exclude && matches(string, querydata.exclude)) {
    return false
  }
  if(querydata.to || querydata.from) {
    // Don't live update with bounds set
    return false
  }
  return true
}

export default {
  data() {
    return {
      activities: [],
      busy:       true,
      no_more:    false
    }
  },
  beforeMount() {
    this.appId = $("#activity-table").attr("app-id")
  },
  mounted() {
    var uri = URI(document.location.toString())
    var params = uri.search(true);

    Cable.subscriptions.create({
      channel: "ActivityChannel",
      app_id: this.appId
    }, {
      received: (data) => {
        if(matchesQuery(params, data)) {
          this.activities.unshift(data);
        }
      }
    });

    $.get(uri, data => {
      this.activities = data
      this.busy = false
    }, "json")
  },
  methods: {
    loadMore() {
      var uri           = URI(document.location.toString())
      var last_activity = this.activities.slice(-1)[0]
      if(!last_activity) {
        this.no_more = true
        return
      }
      this.busy         = true
      $.get( uri.setSearch("from_id", last_activity.id).toString(), data => {
        if(data.length) {
          this.activities.push.apply(this.activities, data)
          this.busy = false
        } else { this.no_more = true }
      }, "json")
    }
  },
  components: {
    ActivityRow
  },
  directives: {
    infiniteScroll
  }
}
</script>

<style scoped>
table {
  table-layout: fixed;
  width: 100%
}
</style>
<style>
.nomore td {
  text-align: center;
}
.time-col {
  width: 120px;
}
.email-col {
  width: 220px;
}
.org-col {
  width: 200px;
}
.action-col {
  width: 180px;
}
.link-col {
  width: 85px;
}
.details-col {
  width: 65px;
}

td, th {
  overflow: hidden;
  padding: 12px !important;
  text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// activity_table.vue?5cd81c4a